import { render, staticRenderFns } from "./event-attributes.vue?vue&type=template&id=3d45e956"
import script from "./event-attributes.vue?vue&type=script&lang=js"
export * from "./event-attributes.vue?vue&type=script&lang=js"
import style0 from "./event-attributes.vue?vue&type=style&index=0&id=3d45e956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports